import { DateTime } from 'luxon';
export function selectedDayIsValid(selectedDate, endTime) {
    return (selectedDate >= DateTime.now().startOf('day') &&
        selectedDate <= endTime.endOf('day'));
}
export var isDateInTimeRanges = function (date, timeRanges) {
    if (timeRanges.length === 0)
        return false;
    for (var i = 0; i < timeRanges.length; i++) {
        if (date >= timeRanges[i].startTime && date <= timeRanges[i].endTime) {
            return true;
        }
    }
    return false;
};
